<div class="cycling-loading-container w-100">
	<div
		class="loading-text"
		[@fadeInOut]="animationState"
		(@fadeInOut.done)="onAnimationDone($event)"
	>
		{{ currentMessage }}
	</div>
</div>
